import Backbone from 'backbone'
import template from './scoring-type-form.hbs'
import i18n from 'scoreboard/components/i18n'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import ScoringTypeModel from './scoring-type-model'
import _ from 'lodash'
import config from 'scoreboard/components/config'
import BoxOptions from 'scoreboard/components/box-options'
import selects from 'scoreboard/components/selects'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import $ from 'jquery'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import unwrapModel from 'scoreboard/components/unwrap-model'
import Tooltip from 'scoreboard/components/tooltip'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import ColorPicker from 'scoreboard/components/color-picker'
import * as colors from 'scoreboard/charts/config/chart-colors'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import numericRangeValidatorFactory from 'scoreboard/components/validators/numeric-range-validator-factory'
import DraggableList from 'draggable-list'
import regexValidatorFactory
	from 'scoreboard/components/validators/regexp-validator-factory'
import { hasExtraColorAbove, hasExtraColorBelow}
	from 'scoreboard/components/has-extra-color-above-below'

import thresholdTemplate from './threshold.hbs'

import constants from 'scoreboard/components/constants'
const {
    NUMBER,
    STABILIZE_NUMBER,
    SCORED_TEXT,
    UNSCORED_TEXT,
    GOAL_RED_FLAG,
    SCORED_MIDDLE_4_COLOR,
    GOAL_ONLY,
    STABILIZE_2,
    STABILIZE_3,
} = constants

import defaultThresholds from './default-thresholds'
import defaultColors from './default-colors'
import deepEqual from 'deep-equal'
import cleanObject from 'scoreboard/components/clean-object'
import formatValue from 'scoreboard/components/format-value'
import errorHandler from 'scoreboard/components/error-handler'
import appDisplay from 'scoreboard/components/app-display'
import ConfirmPrompt from 'scoreboard/components/confirm-prompt'

/** The Standard option for the Type field */
const STANDARD = 'standard'
/** The Custom option for the Type field */
const CUSTOM = 'custom'

let labelPattern = '^[\\p\{L\}\\d _\'\\.]+$'
const labelValidator = regexValidatorFactory(labelPattern, 'admin.appConfiguration.scoringType.alphabetic')

const ScoringTypeForm = Backbone.View.extend(/** @lends {ScoringTypeForm.prototype} */{

	tagName: 'form',

	/** @type {ScoringTypeModel} */
	model: null,

	className: 'scoring-type-form',

	events: {
		'click .add-threshold': 'onClickAddThreshold',
		'click .delete-threshold': 'onClickDeleteThreshold',
		'change [name=standardScoringType]': 'onChangeStandardScoringType',
		'change [name=goal]': 'onChangeGoal'
	},

	/**
	 * Dialog used to add or edit a scoring type (#45581 #22067 #45583)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {ScoringType} options.model
	 */
	initialize: function(options = {}) {
		this.options = options
		if (_.isNil(options.model)) {
			this.model = new ScoringTypeModel()
		}
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: this.model.isNew(),
			test: this.test.bind(this),
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.html(template(this.context()))
		this.renderToggle()
		this.renderStandardScoringTypeSelect()
		this.renderLabelMarkedField()
		this.renderKpiValueTypeOptions()
		this.renderThresholds()
		// must go before renderColorsOutsideThresholds
		formHelper.writeToDom(unwrapModel(this.model), this.getElExcludingThresholds())
		// must go before renderColorsOutsideThresholds
		this.adjustControls()
		this.renderColorsOutsideThresholds()
		this.formView.start()

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		return this
	},

	/**
	 * Re-renders the form based on a recent change the user made
	 */
	rerender: function() {
		this.model.set(this.getSubmitData())
		this.render()
	},

	renderToggle: function() {
		let isStandard = this.model.isNew() ||
			!_.isNil(this.model.get('standardScoringType'))
		isStandard = isStandard && !_.isEmpty(this.getUnusedStandardScoringTypes())
		this.typeToggle = new LabeledToggle({
			name: 'type',
			options: [{
				value: STANDARD,
				label: i18n.get('admin.calendar.standard')
			}, {
				value: CUSTOM,
				label: i18n.get('admin.calendar.custom')
			}],
			value: isStandard ? STANDARD : CUSTOM
		})
		this.$('.toggle-container').append(this.typeToggle.el)
		this.typeToggle.render()

		this.handleAllStandardAdded()

		this.typeToggle.on('change', val => {
			this.clearErrors()
			this.rerender()
			// this needs to be after the render and triggered with the .val
			// call so that the 'select' event handler is triggered on the toggle
			if (val == CUSTOM) {
				this.kpiValueTypeOptions.val(NUMBER)
			}
		})
	},

	/**
	 * Handle all standard scoring types having already been added by displaying
	 * the option and displaying a tooltip
	 */
	handleAllStandardAdded: function() {
		if (_.isEmpty(this.getUnusedStandardScoringTypes())) {
			this.typeToggle.disableOption(STANDARD)
			let standardOptionEl = this.typeToggle.$('.option[data-value=standard]')
			standardOptionEl.on('click', e => {
				let value = $(e.currentTarget).data('value')
				if (value == STANDARD) {
					e.stopPropagation()
					_.invoke(this.tooltip, 'remove')
					this.tooltip = new Tooltip({
						attachTo: standardOptionEl,
						placement: 'above',
						arrow: 'left',
						content: i18n.get('admin.appConfiguration.scoringType.standard.allAdded')
					}).render()
				}
			})
		}
	},

	hasExtraColorBelow: function() {
		let scoringType = this.readFromDom()
		return hasExtraColorBelow({
			kpiValueType: this.kpiValueTypeOptions.val(),
			standardScoringType: scoringType.standardScoringType
		})
	},

	hasExtraColorAbove: function() {
		let scoringType = this.readFromDom()
		return hasExtraColorAbove({
			kpiValueType: this.kpiValueTypeOptions.val(),
			standardScoringType: scoringType.standardScoringType
		})
	},

	renderColorsOutsideThresholds: function(colors = this.model.get('colors')) {
		let fromDom = this.readFromDom()
		let numThresholds = _.size(fromDom.thresholds)
		let stabilize = ScoringTypeForm.isStabilize(fromDom)

		if (this.typeToggle.val() === STANDARD) {
			let standardScoringType = fromDom.standardScoringType
			let scoringType = _.find(config.standardScoringTypes, st =>
				st.standardScoringType == standardScoringType)
			colors = scoringType.colors
		}

		if (_.isEmpty(colors)) {
			colors = ScoringTypeForm.defaultColorsForNumThresholds(
				numThresholds, stabilize)
		}

		// for standard scoring types numThresholds will end up as 0, so just
		// skip this logic b/c it's not needed
		if (numThresholds > 0) {
			// #50082 don't render too many colors
			let numColors = ScoringTypeForm.getNumColors(numThresholds, stabilize)
			colors = colors.slice(0, numColors)
			// #50082 if there's one too few colors, dup the last color
			if (colors.length < numColors) {
				colors.push(colors[colors.length - 1])
			}
		}

		this.$('.colors-outside-thresholds').empty()
		_.each(colors, (color, index) => {
			this.renderColorOutsideThreshold(color, index, colors.length)
		})
		this.applyDashConnectorColors(colors)
	},

	rerenderColorOutsideThresholds: function() {
		this.renderColorsOutsideThresholds(this.getSubmitData().colors)
	},

	renderColorOutsideThreshold: function(color, index, numColors) {
		let isStandard = this.typeToggle.val() === STANDARD
		let dashConnector = '<div class="dash-connector"></div>'
		let extraColorAbove = this.hasExtraColorAbove()
		let extraColorBelow = this.hasExtraColorBelow()

		// Logic to determine if a dash connector should be appended before the
		// first color.
		let allowPreDash = !isStandard && !extraColorBelow ||
			isStandard && !extraColorAbove
		let preDashConnector = index === 0 && allowPreDash ? dashConnector : ''
		// Logic to determine if a dash connector should be appended after the
		// last color.
		let isLastColor = numColors - 1 === index
		let allowPostDash = isLastColor &&
			(!isStandard && !extraColorAbove || isStandard && !extraColorBelow)
		let postDashConnector = !isLastColor || allowPostDash ? dashConnector : ''

		color = color || this.nextDefaultColor()
		let html =
			`${preDashConnector}
			 <div class="color">
				<button type="button" class="color-picker config-color select"></button>
			 </div>
			 ${postDashConnector}`
		this.$('.colors-outside-thresholds').append(html)
		let colorEl = this.$('.colors-outside-thresholds .color').last()

		if (isStandard) {
			colorEl.addClass(color)
		} else {
			this.renderColorPicker(colorEl, color)
		}
	},

	/**
	 * Applies the correct colors to all the dashboard connectors.
	 * @param {String[]} allColors all the colors expressed in the "colors
	 * outside thresholds"
	 */
	applyDashConnectorColors: function(allColors) {
		let scoringType = this.getSubmitData()
		if (scoringType.standardScoringType) {
			scoringType = _.find(config.standardScoringTypes, st =>
				st.standardScoringType == scoringType.standardScoringType)
		}
		let colors = ScoringTypeForm.dashConnectorColors(scoringType,
			allColors, this.hasExtraColorBelow(), this.hasExtraColorAbove())
		_.each(this.$('.dash-connector'), (el, index) => {
			this.$(el).addClass(colors[index])
		})
	},

	/**
	 * Returns the default next color that should be used when adding a new
	 * threshold, if one wasn't already specified
	 */
	nextDefaultColor: function() {
		return _.last(this.readFromDom().colors) || 'green-medium'
	},

	getUnusedStandardScoringTypes: function() {
		if (!this.unusedStandardScoringType) {
			let currentScoringTypes = _.map(config.scoringTypes, 'standardScoringType')
			this.unusedStandardScoringType = _(config.standardScoringTypes)
				.filter(st =>
					!_.includes(currentScoringTypes, st.standardScoringType)
				)
				.map(standardScoringType => {
					let option = _.clone(standardScoringType)
					option.label = i18n.get(option.label)
					option.value = option.standardScoringType
					option.icon = option.standardScoringType
					return option
				})
				.value()
		}
		return this.unusedStandardScoringType
	},

	renderStandardScoringTypeSelect: function() {
		selects(this.$('[name=standardScoringType]'), {
			options: this.getUnusedStandardScoringTypes(),
			selected: this.model.get('standardScoringType')
		})
	},

	renderLabelMarkedField: function() {
		this.labelMarkedField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()
	},

	renderKpiValueTypeOptions: function() {
		let availableOptions = [{
			value: NUMBER,
			title: i18n.get('admin.appConfiguration.scoringType.kpiValueType.number'),
			icon: 'goal-red-flag'
		}, {
			value: STABILIZE_NUMBER,
			title: i18n.get('admin.appConfiguration.scoringType.kpiValueType.stabilize-number'),
			icon: 'stabilize-3'
		}, {
			value: SCORED_TEXT,
			title: i18n.get('admin.appConfiguration.scoringType.kpiValueType.scored-text'),
			icon: SCORED_TEXT
		}, {
			value: UNSCORED_TEXT,
			title: i18n.get('admin.appConfiguration.scoringType.kpiValueType.unscored-text'),
			icon: UNSCORED_TEXT
		}]
		this.kpiValueTypeOptions = new BoxOptions({ availableOptions })
		this.$('.box-options-container').html(this.kpiValueTypeOptions.el)
		this.kpiValueTypeOptions.render()
		this.kpiValueTypeOptions.val(this.model.get('kpiValueType'))

		this.kpiValueTypeOptions.on('select', this.onSelectKpiValueType.bind(this))
	},

	renderThresholds: function(thresholds, colors) {
		// populate the thresholds and colors if they weren't specified
		if (!thresholds) {
			thresholds = this.model.get('thresholds')
			colors = this.model.get('colors')
			if (this.typeToggle.val() === STANDARD) {
				let standardScoringType = this.$('[name=standardScoringType]').val()
				let scoringType = _.find(config.standardScoringTypes, sst =>
					sst.standardScoringType === standardScoringType)
				thresholds = _.map(scoringType.thresholds, threshold => {
					threshold.label = i18n.get(threshold.label)
					// #49435 threshold score for standard scoring types
					// should be displayed with default decimal precision
					threshold.score = formatValue.round(
						threshold.score, config.defaultPrecision)
					return threshold
				})
				colors = scoringType.colors
			}
		}

		this.removeThresholdViewsAndEls()
		this.$('.configurable-list .list').empty()

		// below here actually renders the thresholds

		_.each(thresholds, (threshold, index) => {
			let color
			if (this.kpiValueTypeOptions.val() == SCORED_TEXT) {
				color = _.get(colors, index)
			}
			this.renderThreshold(threshold, color)
		})
		this.renderDraggableValues()
	},

	renderThreshold: function(threshold, color) {
		this.$('.configurable-list .list').append(thresholdTemplate(threshold))
		let el = this.$('.configurable-list ul .item').last()
		this.renderThresholdLabelField(el)
		this.renderColorPicker(el, color || 'green-medium')
		formHelper.writeToDom(threshold, el)
		// must be after writeToDom so percentage scores are rendered properly
		this.renderScoreField(el)
		if (threshold.goal) {
			this.goalEl = el.find('[name=goal]')
			this.goalEl.prop('checked', true)
		}
	},

	renderDraggableValues: function() {
		let list = this.$('.draggable-list')
		if (list.find('.item').length > 1) {
			this.draggableList = new DraggableList(list[0])
			this.draggableList
				.on('dndstop',() => {
					if (this.goalEl) {
						this.goalEl.prop('checked', true)
					}
					this.formView.change()
					this.rerenderColorOutsideThresholds()
				})
		}
	},

	renderThresholdLabelField: function(el) {
		// can be retrieved later by querying the DOM or calling
		// this.thresholdLabelFields
		new MarkedField({
			el: el.find('.threshold-label input'),
			validators: [requiredValidator, labelValidator]
		}).render()
	},

	/**
	 * Returns the MarkedFields for each of the threshold labels
	 */
	thresholdLabelFields: function() {
		return this.viewsFromEls(this.$('.threshold-label input'))
	},

	scoreFields: function() {
		return this.viewsFromEls(this.$('.score input'))
	},

	colorPickers: function() {
		return this.viewsFromEls(this.$('.color-picker'))
	},

	/**
	 * Returns the Backbone.Views attached to the given elements
	 */
	viewsFromEls: function(els) {
		return _.map(this.$(els), el => this.$(el).data('view'))
	},

	renderColorPicker: function(el, color) {
		color = color || 'green-medium'
		// can access these later at this.colorPickers()
		let colorPicker = new ColorPicker({
			el: el.find('.color-picker'),
			colors: colors.grouped()
		})
		colorPicker.render()
		colorPicker.color(color)
		this.setColorIndicator(colorPicker.$el, color)
		colorPicker.on('select', color => {
			colorPicker.color(color)
			this.setColorIndicator(colorPicker.$el, color)
			this.rerenderColorOutsideThresholds()
			this.formView.change()
		})
	},

	setColorIndicator: function(colorPickerEl, color, setColorPicker) {
		let colorPicker
		if (setColorPicker) {
			colorPicker = this.colorPickers().find(x => {
				return x.$el[0].isSameNode(colorPickerEl[0])
			})
			colorPicker.color(color)
		}

		let container = colorPickerEl.closest('.color')
		let prevColor = container.data('color')
		container
			.removeClass(prevColor)
			.addClass(color)
			.data('color', color)
	},

	renderScoreField: function(el) {
		let validators = [requiredValidator]
		if (config.allowScoresBelowMin || config.allowScoresAboveMax) {
			let min = config.allowScoresBelowMin ? null : config.minimumScore
			let max = config.allowScoresAboveMax ? null : config.maximumScore
			let numericRangeValidator =
				numericRangeValidatorFactory(min, max, { dataType: 'score' })
			validators.push(numericRangeValidator)
		}
		// can call this.scoreFields() to retrieve these
		new MarkedField({
			el: el.find('.score input'),
			dataType: 'score',
			evaluator: numericEvaluator,
			validator: validators
		}).render()
	},

	/**
	 * Callback when changing the KPI Value Type (number, stabilize number,
	 * scored text, unscored text)
	 */
	onSelectKpiValueType: function(newOption, oldOption) {
		let oldKpiValueType = _.get(oldOption, 'value')
		if (this.allowPrefill(oldKpiValueType)) {
			this.prefillDefaults()
		} else {
			this.renderColorsOutsideThresholds()
		}
		// must be after prefillDefaultThresholds to function properly
		this.adjustControls()
		this.formView.change()
		// the error messages for one metric value type probably don't apply
		// to other metric value types
		this.formView.clearErrors()
	},

	/**
	 * Determines whether we will prefill default colors and thresholds
	 */
	allowPrefill: function(oldKpiValueType) {
		let domThresholds = this.readFromDom().thresholds
		// we can prefill when there aren't any defined thresholds
		return _.size(domThresholds) == 0 ||
			// we can prefill if we didn't previously have any thresholds
			// displayed
			_.isNil(oldKpiValueType) ||
			// we can also prefill if we're still showing the defaults
			deepEqual(defaultThresholds(oldKpiValueType), domThresholds)
	},

	prefillDefaults: function() {
		let kpiValueType = this.kpiValueTypeOptions.val()
		let colors = defaultColors(kpiValueType)
		// render the new thresholds
		this.renderThresholds(defaultThresholds(kpiValueType),
			colors)
		this.renderColorsOutsideThresholds(colors)
	},

	onClickAddThreshold: function() {
		this.renderThreshold({}, this.nextDefaultColor())
		this.renderColorOutsideThreshold()
		this.formView.change()
		this.renderDraggableValues()
		this.adjustControls()
		this.rerenderColorOutsideThresholds()
	},

	onClickDeleteThreshold: function(e) {
		let el = this.$(e.target).closest('[data-id]')

		function removeAndSplice(array, index) {
			_.invoke(array[index], 'remove')
			array.splice(index, 1)
		}

		let index = el.index()
		removeAndSplice(this.thresholdLabelFields(), index)
		removeAndSplice(this.scoreFields(), index)
		// when there aren't scores below the minimum, we'll have one fewer
		// color at the beginning to worry about
		if (!config.allowScoresBelowMin) {
			index--
		}
		let colorsOutsideThresholds = this.$('.colors-outside-thresholds .color')
		// must be before we modify colorsOutsideThresholds
		removeAndSplice(this.colorPickers(), index)
		// must be after we modify colorPickers
		removeAndSplice(colorsOutsideThresholds, index)

		el.remove()
		this.formView.change()
		this.adjustControls()
	},

	onChangeStandardScoringType: function() {
		this.removeThresholdViewsAndEls()
		this.renderThresholds()
		this.renderColorsOutsideThresholds()
		// must go last
		this.adjustControls()
	},

	onChangeGoal: function(e) {
		this.goalEl = this.$(e.currentTarget)
		this.rerenderColorOutsideThresholds()
	},

	getThresholdViewsAndEls: function() {
		let colorsOutsideThresholds = this.$('.colors-outside-thresholds .color')
		return [this.thresholdLabelFields(), this.colorPickers(), this.scoreFields(), colorsOutsideThresholds]
	},

	/**
	 * Adjusts controls so that they are appropriate for the given scoring type.
	 * Mostly toggles control visibility, but also changes some labels
	 */
	adjustControls: function() {
		this.toggleThresholdControls()
		this.toggleStandardControls()
		this.toggleThresholdLabelField()
		this.adjustAddThresholdLabel()
		this.adjustThresholdsLabel()
		this.toggleThresholds()
		this.adjustColorsOutsideThresholds()
		this.lockScoreExtremes()
	},

	/** Toggles the threshold controls based on scoring type */
	toggleThresholdControls: function() {
		// show scores for all KPI Value Types except unscored text
		let isUnscoredText = this.kpiValueTypeOptions.val() === UNSCORED_TEXT
		this.$('.score').toggleClass('is-not-displayed', isUnscoredText)

		// show the color picker only for scored text
		this.$('.threshold .color').toggleClass(
			'is-not-displayed', this.kpiValueTypeOptions.val() !== SCORED_TEXT)

		this.$('.threshold-label').toggleClass('is-full-width', isUnscoredText)

		let displayGoal = _.includes([NUMBER, SCORED_TEXT],
			this.kpiValueTypeOptions.val())
		this.$('.item').toggleClass('is-hiding-goal', !displayGoal)
		this.$('.item .goal').toggleClass('is-not-displayed', !displayGoal)
	},

	/**
	 * Toggles controls based on whether this is a standard scoring type
	 */
	toggleStandardControls: function() {
		let isStandard = this.typeToggle.val() === STANDARD
		this.$el.toggleClass('has-color-pickers', !isStandard)
		this.$('.standard-scoring-type').toggleClass('is-not-displayed',
			!isStandard)

		this.$('.label, .kpi-value-type').toggleClass('is-not-displayed', isStandard)

		// only show the inline colors for custom text
		let showInlineColors = !isStandard && this.kpiValueTypeOptions.val() == SCORED_TEXT
		this.$('.thresholds .item .color-picker-container').toggleClass(
			'is-not-displayed', !showInlineColors)

		// for standard scoring types, hide edit controls
		if (isStandard) {
			this.$('.thresholds input').attr('disabled', true)
			this.$('.delete-configuration-item, .grip-container')
				.addClass('is-not-displayed')
		}
		this.$('.draggable-list li').toggleClass('draggable-list-nodrag', isStandard)
		this.$('.add-threshold').toggleClass('is-not-displayed', isStandard)
	},

	/**
	 * Changes the label for the threshold label field. Will either be
	 * "Name" or "Text Value"
	 */
	toggleThresholdLabelField: function() {
		let thresholdLabel = this.isCustomText() ?
			'admin.appConfiguration.scoringType.textValue' : 'common.name'
		this.$('.threshold-label .label-text').text(i18n.get(thresholdLabel))
	},

	/** Shows an appropriate label for the "Add Threshold" button */
	adjustAddThresholdLabel: function() {
		let addWhat = this.isCustomText() ? 'common.value' :
			'report.customReport.metricThreshold'
		this.$('.add-threshold .add-threshold-label').text(
			i18n.get('common.add2', addWhat))
	},

	/**
	 * Shows an appropriate label above the thresholds. Either "KPI Values"
	 * "Thresholds"
	 */
	adjustThresholdsLabel: function() {
		let thresholdsKey = this.isCustomText() ? 'admin.ownersUpdaters.metricValues' :
			'report.customReport.metricThresholds'
		this.$('.thresholds-label').text(i18n.get(thresholdsKey))
	},

	/**
	 * Hides the thresholds entirely for yes/no metrics (#48886) and when a KPI
	 * value type hasn't been selected yet (#49065)
	 */
	toggleThresholds: function() {
		let hidingThresholds = ScoringTypeForm.isHidingThresholds({
			type: this.typeToggle.val(),
			standardScoringType: this.$('[name=standardScoringType]').val(),
			kpiValueType: this.kpiValueTypeOptions.val()
		})
		this.$('.thresholds-label, .thresholds').toggleClass('is-not-displayed',
			hidingThresholds)
	},

	/**
	 * Adjusts the display for the colors which appear outside thresholds
	 */
	adjustColorsOutsideThresholds: function() {
		let hasColorsOutsideThresholds =
			this.typeToggle.val() == STANDARD ||
			_.includes(['number', 'stabilize-number'], this.kpiValueTypeOptions.val())
		// `.has-colors-outside-thresholds` shows the layout with the stacked
		// colors on the left.
		this.$el.toggleClass('has-colors-outside-thresholds',
			hasColorsOutsideThresholds)
		this.$('.colors-outside-thresholds').toggleClass('is-not-displayed',
			!hasColorsOutsideThresholds)

		// Toggle the correct classes for positioning
		// the stacked colors on the left correctly
		this.$el.toggleClass('has-extra-color-below',
			this.hasExtraColorBelow())
		this.$el.toggleClass('has-extra-color-above',
			this.hasExtraColorAbove())

		// show all the thresholds. then we'll selectively hide/show the first
		// and last below
		this.$('.colors-outside-thresholds .color').removeClass('is-not-displayed')
	},

	/**
	 * Locks the minimum and maximum thresholds so that they can't be deleted
	 * and their scores can't be edited. This only applies when
	 * allowScoresBelowMin or allowScoresAboveMax is false.
	 */
	lockScoreExtremes: function() {
		// only apply the logic below for custom  scoring types
		if (this.typeToggle.val() != CUSTOM) {
			return
		}

		let kpiValueType = this.kpiValueTypeOptions.val()
		if (!_.includes([NUMBER, STABILIZE_NUMBER], kpiValueType)) {
			return
		}

		let scoringType = this.getSubmitData()
		let scores = _.map(scoringType.thresholds, 'score')
		let numMinScores = _.filter(scores, score =>
			score == config.minimumScore).length
		_.each(this.$('.threshold'), el => {
			el = $(el)
			let scoreEl = el.find('[name=score]')
			let score = parseFloat(scoreEl.data('view').val())
			let lockThresholdAndScore = false
			if (!config.allowScoresBelowMin && config.minimumScore == score) {
				lockThresholdAndScore = true
			}
			if (!config.allowScoresAboveMax && config.maximumScore == score) {
				lockThresholdAndScore = true
			}
			// for number scoring types, if there's more than one minimum score
			// found, don't lock the minimum scores so that we can remove one of
			// them
			if (kpiValueType == NUMBER &&
				score == config.minimumScore &&
				numMinScores >= 2) {
				lockThresholdAndScore = false
			}
			if (lockThresholdAndScore) {
				// for stabilize, lock the minimum and maximum scores
				scoreEl.prop('disabled', lockThresholdAndScore)
				// for stabilize, hide the delete button for the min and max thresholds
				el.find('.delete-threshold').toggleClass('is-not-displayed', lockThresholdAndScore)
			}
		})
	},

	isCustomText: function() {
		return this.typeToggle.val() == CUSTOM &&
			_.includes([SCORED_TEXT, UNSCORED_TEXT],
				this.kpiValueTypeOptions.val())
	},

	context: function() {
		let scoringTypeMsg = i18n.get('report.customReport.scoringType')
		let existing = this.model && !this.model.isNew()
		let titleKey = existing ? 'common.edit2' : 'common.add2'
		let title = i18n.get(titleKey, scoringTypeMsg)
		let doneKey = existing ? 'common.save' : 'common.add'
		return { title, doneKey }
	},

	/**
	 * Returns DOM elements except those relating to the thresholds
	 */
	getElExcludingThresholds: function() {
		return this.$('.dialog-body-content > :not(.thresholds)')
	},

	/**
	 * @return {ScoringType}
	 */
	readFromDom: function() {
		let scoringType = formHelper.readFromDom(this.getElExcludingThresholds())
		scoringType.id = this.model.id
		let colorPickers = _.map(this.$('.color-picker:visible'), el =>
			$(el).data('view'))
		if (this.typeToggle.val() == CUSTOM) {
			let kpiValueType = this.kpiValueTypeOptions.val()
			scoringType.kpiValueType = kpiValueType
			let thresholdEls = this.$('.thresholds .item:visible')
			scoringType.thresholds = _.map(thresholdEls, (itemEl, index) => {
				let threshold = formHelper.readFromDom(itemEl)
				threshold.id = this.$(itemEl).data('id')
				if (_.isNil(threshold.score)) {
					delete threshold.score
				} else {
					threshold.score = parseFloat(threshold.score)
				}
				// cleanObject for when we test deepEquals in allowPrefill
				return cleanObject(threshold, { nonEmpty: true })
			})
			if (this.kpiValueTypeOptions.val() !== UNSCORED_TEXT) {
				scoringType.colors = _.map(colorPickers, cp =>
					_.result(cp, 'val'))
			}
		}
		console.dir(scoringType)
		return cleanObject(scoringType) // to simplify tests
	},

	clearErrors: function() {
		_.invoke(this.labelMarkedField, 'clearError')
		_.invokeMap(this.thresholdLabelFields(), 'clearError')
		_.invokeMap(this.scoreFields(), 'clearError')
	},

	test: function() {
		let scoringType = this.getSubmitData()
		let scores = _.map(scoringType.thresholds, 'score')
		let kpiValueType = this.kpiValueTypeOptions.val()
		let thresholdLabels = _.map(scoringType.thresholds, 'label')

		return this.testKpiValueTypeSpecified(kpiValueType) ||
			this.testGoalSpecified(kpiValueType, scoringType) ||
			this.testEnoughThresholdsSpecified(kpiValueType, scores) ||
			ScoringTypeForm.testMinMaxScorePresent(kpiValueType, scores) ||
			ScoringTypeForm.testMaxNumberThresholds(scores, this.isCustomText()) ||
			ScoringTypeForm.testUniqueThresholdLabels(thresholdLabels, this.isCustomText()) ||
			ScoringTypeForm.testScoreOrder(kpiValueType, scores) ||
			ScoringTypeForm.testMinMaxScoresNotExceeded(kpiValueType, scores)
	},

	testKpiValueTypeSpecified: function(kpiValueType) {
		if (this.typeToggle.val() == CUSTOM &&
			_.isEmpty(kpiValueType)) {
			return i18n.get('admin.appConfiguration.scoringType.kpiValueType.required')
		}
	},

	testGoalSpecified: function(kpiValueType, scoringType) {
		if (_.includes([SCORED_TEXT, NUMBER], kpiValueType)) {
			let goalIndex = scoringType.goalIndex
			if (!_.isNumber(goalIndex) || goalIndex < 0) {
				let key = 'admin.appConfiguration.scoringType.kpiValues.goal.required'
				if (kpiValueType == NUMBER) {
					key += '.number'
				}
				return i18n.get(key)
			}
		}
	},

	testEnoughThresholdsSpecified: function(kpiValueType, scores) {
		if (kpiValueType === NUMBER) {
			if (scores.length < 2) {
				return i18n.get('scorecards.node.metric.minThresholds', 2,
					'admin.appConfiguration.scoringType.kpiValueType.number')
			}
		}

		if (kpiValueType === STABILIZE_NUMBER) {
			if (scores.length < 3) {
				return i18n.get('scorecards.node.metric.minThresholds', 3,
					i18n.get('admin.appConfiguration.scoringType.kpiValueType.stabilize-number'))
			}
		}
	},

	/**
	 * Retrieves data appropriate to the server, with the goalIndex properly
	 * specified and the goal property inferred for stabilize metrics. This
	 * can't go inside the readFromDom method because that causes problems when
	 * switching KPI Value Types
	 * @returns {ScoringType}
	 */
	getSubmitData: function() {
		let scoringType = this.readFromDom()
		if (this.typeToggle.val() == CUSTOM) {
			if (_.includes([SCORED_TEXT, NUMBER], this.kpiValueTypeOptions.val())) {
				scoringType.goalIndex = _.findIndex(scoringType.thresholds,
					threshold => threshold.goal == 'true')
			}
			if (this.kpiValueTypeOptions.val() === STABILIZE_NUMBER &&
				!_.isEmpty(scoringType.thresholds)) {
				scoringType.goalIndex = _.findIndex(scoringType.thresholds,
					threshold => threshold.score == config.maximumScore)
				if (scoringType.goalIndex != -1) {
					scoringType.thresholds[scoringType.goalIndex].goal = 'true'
				}
			}
		}
		return cleanObject(scoringType) // to simplify tests
	},

	submit: function() {
		// #50524 if this is the scoring type for non-kpis, supply a full score
		// calc prompt
		if (this.model.id == config.nonMetricScoringTypeId) {
			let recalcPrompt = new ConfirmPrompt({
				titleKey: 'admin.recalcScores',
				messageKey: 'admin.recalcScoresConfirm',
				confirmLabel: 'admin.recalcScores.recalculate',
				cancelLabel: 'common.cancel',
				onConfirm: () => {
					this._submit()
				}
			})
			recalcPrompt.once('cancel', () => this.formView.resetForm())
			appDisplay.dialog(recalcPrompt)
		} else {
			this._submit()
		}
	},

	_submit: function() {
		let scoringType = this.getSubmitData()
		return $.ajax({
			type: 'post',
			url: `api/admin/scoring-types`,
			data: JSON.stringify(scoringType),
			success: scoringTypes => {
				config.scoringTypes = scoringTypes
				if (_.isNil(scoringType.id)) {
					// new scoring types are added at the end of the list. grab
					// the last one if needed so we have the ID
					scoringType = _.last(scoringTypes)
				}
				this.trigger('done', scoringType)
			},
			error: xhr => errorHandler(xhr, { formView: this.formView })
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeComponents()
	},

	removeComponents: function() {
		_.invokeMap([this.typeToggle, this.labelMarkedField,
				this.kpiValueTypeOptions, this.formView, this.kpiValues, this.tooltip,
				this.covertButtonTooltips, this.draggableList],
			'remove')
		_.invokeMap(this.thresholdLabelFields(), 'remove')
	},

	/**
	 * Clean up all the threshold views and elements
	 */
	removeThresholdViewsAndEls: function() {
		_.each(this.getThresholdViewsAndEls(), viewsOrEls => {
			_.invokeMap(viewsOrEls, 'remove')
			// mutate the array so that it is empty
			viewsOrEls && viewsOrEls.splice(0, viewsOrEls.length)
		})
	}

}, {

	/** Indicates a standard scoring type built into the software */
	STANDARD,
	/** Indicates a scoring type defined by a user of the software */
	CUSTOM,

	/**
	 * Validates that the given scores are in either ascending
	 * numeric order. Assumes at least two scores are passed in, and that all
	 * scores are numeric (which is already validated elsewhere).
	 */
	validNumberScoreOrder: function(scores) {
		let allAscending = true
		for (let i=0; i<scores.length-1; i++) {
			let score1 = scores[i]
			let score2 = scores[i+1]
			allAscending = allAscending && score1 < score2
		}
		return allAscending
	},

	/**
	 * Verifies the scores for the thresholds are listed in the correct order
	 */
	testScoreOrder: function(kpiValueType, scores) {
		if (_.includes([NUMBER, SCORED_TEXT], kpiValueType)) {
			if (!ScoringTypeForm.validNumberScoreOrder(scores)) {
				return i18n.get('scorecards.node.metric.invalidScoreOrder',
					ScoringTypeForm.getFormattedMinScore(),
					ScoringTypeForm.getFormattedMaxScore())
			}
		}
		if (kpiValueType == STABILIZE_NUMBER) {
			if (!ScoringTypeForm.validStabilizeScoreThresholds(scores)) {
				return i18n.get('scorecards.node.metric.invalidScoreOrder.stabilize')
			}
		}
	},

	/**
	 * Validates that the threshold/kpi value labels are unique
	 * #50140
	 */
	testUniqueThresholdLabels: function(thresholdLabels, isCustomText) {
		const uniqueLabels =
			_.uniqBy(thresholdLabels, label => label?.toLowerCase())
		if (thresholdLabels.length !== uniqueLabels.length) {
			return i18n.get(
				'admin.appConfiguration.scoringType.uniqueThresholdNames',
				ScoringTypeForm.thresholdsKey(isCustomText))
		}
	},

	thresholdsKey: function(isCustomText) {
		return isCustomText ?
			'admin.ownersUpdaters.metricValues' :
			'report.customReport.metricThresholds'
	},

	testMaxNumberThresholds: function(scores, isCustomText) {
		if (scores?.length > 7) {
			return i18n.get('scorecards.node.metric.maxThresholds',
				ScoringTypeForm.thresholdsKey(isCustomText))
		}
	},

	testMinMaxScorePresent: function(kpiValueType, scores) {
		// #60767 don't require min/max scores for SCORED_TEXT
		if (![NUMBER, STABILIZE_NUMBER].includes(kpiValueType)) return

		if (!config.allowScoresBelowMin) {
			let hasMinScore = _.some(scores, s =>
				s == config.minimumScore)
			if (!hasMinScore) {
				return i18n.get('scorecards.node.metric.missingMinScore',
					ScoringTypeForm.getFormattedMinScore())
			}
		}
		if (!config.allowScoresAboveMax) {
			let hasMaxScore = _.some(scores, s =>
				s == config.maximumScore)
			if (!hasMaxScore) {
				return i18n.get('scorecards.node.metric.missingMaxScore',
					ScoringTypeForm.getFormattedMaxScore())
			}
		}
	},

	testMinMaxScoresNotExceeded: function(kpiValueType, scores) {
		if (![NUMBER, STABILIZE_NUMBER, SCORED_TEXT].includes(kpiValueType)) return


		if (!config.allowScoresBelowMin) {
			let exceedsMin = _.some(scores, score =>
				score < config.minimumScore)
			if (exceedsMin) {
				return i18n.get('scorecards.node.metric.minScoreExceeded',
					ScoringTypeForm.getFormattedMinScore())
			}
		}
		if (!config.allowScoresAboveMax) {
			let exceedsMax = _.some(scores, score =>
				score > config.maximumScore)
			if (exceedsMax) {
				return i18n.get('scorecards.node.metric.maxScoreExceeded',
					ScoringTypeForm.getFormattedMaxScore())
			}
		}

	},

	getFormattedMinScore: function() {
		return formatValue({ value: config.minimumScore, dataType: 'score'})
	},

	getFormattedMaxScore: function() {
		return formatValue({ value: config.maximumScore, dataType: 'score'})
	},

	/**
	 * Validates that the given scores are in a valid order for a stabilize
	 * metric. For stabilize, the highest value has to be in the middle, and
	 * then decrease when moving further away from the middle value. Assumes at
	 * least three scores are passed in, and that all scores are numeric. This
	 * is already validated elsewhere.
	 */
	validStabilizeScoreThresholds: function(scores) {
		let max = _.max(scores)
		let maxIndex = _.indexOf(scores, max)
		for (let i=0; i<maxIndex; i++) {
			let score1 = scores[i]
			let score2 = scores[i+1]
			if (score1 >= score2) return false
		}
		for (let i=maxIndex; i<scores.length; i++) {
			let score1 = scores[i]
			let score2 = scores[i+1]
			if (score1 <= score2) return false
		}
		return true
	},

	/**
	 * Returns whether we're hiding the thresholds. Thresholds need to be hidden
	 * for yes/no metrics (#48886) and when a KPI value type hasn't been
	 * selected yet (#49065)
	 * @param {String} type Either STANDARD or CUSTOM
	 * @param {String} standardScoringType
	 * @param {String} kpiValueType
	 */
	isHidingThresholds: function({ type, standardScoringType, kpiValueType }) {
		if (type === STANDARD) {
			return standardScoringType === 'yes-no'
		} else {
			// #49065 don't show thresholds if a KPI value type hasn't been
			// selected yet
			return _.isEmpty(kpiValueType)
		}
	},

	/**
	 * Retrieves how many colors should be allowed based on the number of
	 * thresholds and the below/above settings.
	 */
	getNumColors: function(numThresholds,
			stabilize = false,
			allowScoresBelowMin = config.allowScoresBelowMin,
			allowScoresAboveMax = config.allowScoresAboveMax) {
		// if allowScoresBelowMin and allowScoresAboveMax are both false,
		// we just have colors between the thresholds so the number of colors
		// is the number of thresholds minus one
		let numColors = numThresholds - 1
		if (stabilize) {
			if (allowScoresBelowMin) numColors = numColors + 2
		} else {
			if (allowScoresBelowMin) numColors++
			if (allowScoresAboveMax) numColors++
		}
		return numColors
	},

	defaultColorsForNumThresholds: function(numThresholds,
			stabilize = false,
			allowScoresBelowMin = config.allowScoresBelowMin,
			allowScoresAboveMax = config.allowScoresAboveMax) {
		// we could get fancier maybe, but anything we put in would be a guess
		// so might as well keep things simple. also, we shouldn't be hitting
		// this condition very often
		let numColors = ScoringTypeForm.getNumColors(numThresholds, stabilize,
			allowScoresBelowMin, allowScoresAboveMax)
		return _.times(numColors, () => 'green-medium')
	},

	/**
	 * Returns the colors for the dash connectors. These connectors indicate the
	 * colors when a score exactly equals a particular threshold
	 * @param {ScoringType|ScoringTypeModel} scoringType
	 * @param {String[]} allColors all the colors expressed in the "colors
	 * outside thresholds"
	 * @param {Boolean} [allowScoresBelowMin=config.allowScoresBelowMin]
	 * @param {Boolean} [allowScoresAboveMax=config.allowScoresAboveMax]
	 */
	dashConnectorColors: function(scoringType,
			allColors,
			allowScoresBelowMin = config.allowScoresBelowMin,
			allowScoresAboveMax = config.allowScoresAboveMax) {
		scoringType = unwrapModel(scoringType)
		switch (scoringType.standardScoringType) {
			case GOAL_ONLY: return ['green-medium']
			case GOAL_RED_FLAG: return ['red-medium','green-medium']
			case SCORED_MIDDLE_4_COLOR: return ['red-medium','green-medium','green-dark']
		}

		let connectorColors = []
		let numColors = allColors.length - 1
		if (scoringType.standardScoringType == null) {
			if (!allowScoresBelowMin) numColors++
			if (!allowScoresAboveMax) numColors++
		} else {
			numColors += 2
		}
		for (let i=0; i<numColors; i++) {
			let color
			let extraColorBelowMin = allowScoresBelowMin
			if (scoringType.standardScoringType != null) {
				extraColorBelowMin = false
			}
			if (ScoringTypeForm.isStabilize(scoringType)) {
				color = getStabilizeDashConnectorColor(scoringType, allColors,
					extraColorBelowMin, i)
			} else {
				color = getNumericDashConnectorColor(scoringType, allColors,
					extraColorBelowMin, i)
			}
			connectorColors.push(color)
		}
		return connectorColors
	},

	/**
	 * Returns whether the scoring type is for a stabilize metric
	 * @param {ScoringType|ScoringTypeModel} scoringType
	 */
	isStabilize: function(scoringType) {
		scoringType = unwrapModel(scoringType)
		return scoringType.kpiValueType === STABILIZE_NUMBER ||
			_.includes([STABILIZE_2, STABILIZE_3], scoringType.standardScoringType)
	}

})

/**
 * For a stabilize scoring type, returns the color for a dash connector at a
 * particular index. These connectors indicate the colors when a score exactly
 * equals a particular threshold
 * @param {ScoringType|ScoringTypeModel} scoringType
 * @param {String[]} allColors all the colors expressed in the "colors
 * outside thresholds"
 * @param {Boolean} extraColorBelowMin indicates an extra color is displayed
 * below the minimum threshold
 * @param thresholdIndex the index of the threshold the connector touches
 * @return {String} the color
 */
function getStabilizeDashConnectorColor(scoringType, allColors, extraColorBelowMin, thresholdIndex) {
	// CODE HERE ADAPTED FROM BaseScoringFunctionImplementor.determineColor
	if (thresholdIndex == scoringType.goalIndex - 1) {
		// if we're immediately to the left of the goal, we want the
		// color to the right which is the one closer to the goal
		return getRightColor(allColors, extraColorBelowMin, thresholdIndex)
	} else if (thresholdIndex == scoringType.goalIndex + 1) {
		// if we're just past the goal, we want the color on the
		// left, which is the one closer to the goal.
		return getLeftColor(allColors, extraColorBelowMin, thresholdIndex)
	} else if (thresholdIndex < scoringType.goalIndex) {
		// if we're to the left of the goal but not just next to it,
		// we want the color on the left
		return getLeftColor(allColors, extraColorBelowMin, thresholdIndex)
	} else if (thresholdIndex > scoringType.goalIndex) {
		// if we're to the right of the goal but not just next to
		// it, we want the color on the right
		return getRightColor(allColors, extraColorBelowMin, thresholdIndex)
	} else {
		// if we're at the goal, it could make sense to color =
		// either the color on the left or right, so we'll
		// arbitrarily pick the one on the right
		return getRightColor(allColors, extraColorBelowMin, thresholdIndex)
	}
}

/**
 * For a numeric scoring type, returns the color for a dash connector at a
 * particular index. These connectors indicate the colors when a score exactly
 * equals a particular threshold
 * @param {ScoringType|ScoringTypeModel} scoringType
 * @param {String[]} allColors all the colors expressed in the "colors
 * outside thresholds"
 * @param {Boolean} allowScoresBelowMin whether scores are allowed to be below
 * the minimum score
 * @param thresholdIndex the index of the threshold the connector touches
 * @return {String} the color
 */
function getNumericDashConnectorColor(scoringType, allColors, allowScoresBelowMin, thresholdIndex) {
	if (thresholdIndex < scoringType.goalIndex) {
		return getLeftColor(allColors, allowScoresBelowMin, thresholdIndex)
	} else {
		return getRightColor(allColors, allowScoresBelowMin, thresholdIndex)
	}
}

/**
 * Returns the color to the left of the given threshold index. Similar code in
 * BaseScoringFunctionImplementor.java
 * @param {String[]} colors the colors to pick from
 * @param {Boolean} extraColorBelowMin indicates an extra color is displayed
 * below the minimum threshold
 * @param thresholdIndex the index of the threshold the connector touches
 * @return {String} the color
 */
function getLeftColor(colors, extraColorBelowMin, thresholdIndex) {
	let colorIndex
	if (extraColorBelowMin) {
		colorIndex = thresholdIndex
	} else {
		colorIndex = thresholdIndex - 1
	}
	if (colorIndex < 0) {
		colorIndex = 0
	}
	return colors[colorIndex]
}

/**
 * Returns the color to the right of the given threshold index. Similar code in
 * BaseScoringFunctionImplementor.java
 * @param {String[]} colors the colors to pick from
 * @param {Boolean} extraColorBelowMin indicates an extra color is displayed
 * below the minimum threshold
 * @param thresholdIndex the index of the threshold the connector touches
 * @return {String} the color
 */
function getRightColor(colors, extraColorBelowMin, thresholdIndex) {
	let colorIndex
	if (extraColorBelowMin) {
		colorIndex = thresholdIndex + 1
	} else {
		colorIndex = thresholdIndex
	}
	if (colorIndex > colors.length - 1) {
		colorIndex = colors.length - 1
	}
	return colors[colorIndex]
}

_.extend(ScoringTypeForm, {
	labelValidator
})
export default ScoringTypeForm
export { labelValidator }

ScoringTypeForm.__filename__ = 'admin/scoring-types/scoring-type-form.js'
